// extracted by mini-css-extract-plugin
module.exports = {"EpisodeStatusLabel":"styles_EpisodeStatusLabel__30Sbl","EpisodeApplicationStatusLabel":"styles_EpisodeApplicationStatusLabel__qQZ4z"};